import { render, staticRenderFns } from "./RecActivity.vue?vue&type=template&id=0979bf2e&scoped=true"
import script from "./RecActivity.vue?vue&type=script&lang=js"
export * from "./RecActivity.vue?vue&type=script&lang=js"
import style0 from "./RecActivity.vue?vue&type=style&index=0&id=0979bf2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979bf2e",
  null
  
)

export default component.exports